var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardsFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#5A7ED7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1185_2701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0361 27.2988C30.9846 27.2988 34.1855 24.0979 34.1855 20.1494C34.1855 16.2009 30.9846 13 27.0361 13C23.0876 13 19.8867 16.2009 19.8867 20.1494C19.8867 24.0979 23.0876 27.2988 27.0361 27.2988Z",
    fill: "#FFAD0E",
    stroke: "#FFCE35",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7879 20.4148C28.6881 20.4148 28.6382 20.3316 28.6881 20.2484C28.6881 20.2484 28.9544 19.6992 28.9544 19.333C28.9544 18.3012 28.1222 17.4691 27.0904 17.4691C26.0586 17.4691 25.2265 18.3012 25.2265 19.333C25.2265 20.3649 26.0586 21.197 27.0904 21.197C27.5231 21.197 28.0057 20.9307 28.0057 20.9307C28.089 20.8808 28.1722 20.9307 28.1722 21.0306V21.7961C28.1722 21.896 28.2554 21.9792 28.3552 21.9792H29.1874C29.2872 21.9792 29.3704 22.0624 29.3704 22.1623V23.1608C29.3704 23.2607 29.2872 23.3439 29.1874 23.3439H28.1888C28.089 23.3439 28.0057 23.2607 28.0057 23.1608V22.3453C28.0057 22.2455 27.9225 22.1789 27.8227 22.2122C27.8227 22.2122 27.4399 22.312 27.0571 22.312C25.4095 22.312 24.0781 20.9806 24.0781 19.333C24.0781 17.6854 25.4095 16.354 27.0571 16.354C28.7047 16.354 30.0361 17.6854 30.0361 19.333C30.0361 19.6825 29.8697 20.2484 29.8697 20.2484C29.8364 20.3482 29.7366 20.4314 29.6367 20.4314H28.7547L28.7879 20.4148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1141 27.1311H15.6195C15.0401 27.1311 14.5703 27.5896 14.5703 28.1553V29.6815C14.5703 30.2472 15.0401 30.7058 15.6195 30.7058H37.1141C37.6936 30.7058 38.1633 30.2472 38.1633 29.6815V28.1553C38.1633 27.5896 37.6936 27.1311 37.1141 27.1311Z",
    fill: "#EE7233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4336 30.7058H35.3071L33.5984 39.1544C33.4987 39.6481 33.0911 40 32.6193 40H20.4346C19.9755 40 19.5753 39.6668 19.4615 39.191L17.4336 30.7058Z",
    fill: "#C6B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4469 27.065L12.9774 20.2049C12.9774 20.2049 12.1286 19.4857 11.3468 20.187C10.5669 20.8884 11.3461 22.1223 11.3461 22.1223L15.819 27.0659H18.7868L19.4469 27.065Z",
    fill: "#FFCE35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0062 27.065L40.4757 20.2049C40.4757 20.2049 41.3245 19.4857 42.1063 20.187C42.8862 20.8884 42.1071 22.1223 42.1071 22.1223L37.6341 27.0659H34.6663L34.0062 27.065Z",
    fill: "#FFCE35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.0498,
    y: 33.7442,
    width: 0.35747,
    height: 3.21723,
    rx: 0.178735,
    stroke: "white",
    strokeWidth: 0.35747
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.1944,
    y: 33.7442,
    width: 0.35747,
    height: 3.21723,
    rx: 0.178735,
    stroke: "white",
    strokeWidth: 0.35747
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.3389,
    y: 33.7442,
    width: 0.35747,
    height: 3.21723,
    rx: 0.178735,
    stroke: "white",
    strokeWidth: 0.35747
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1185_2701",
    x: 6.2,
    y: 12.25,
    width: 41.0531,
    height: 37.35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1185_2701"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1185_2701",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsFilled);
export default __webpack_public_path__ + "static/media/rewards_filled.a35b310bab1f7a57990a837a2124b9fc.svg";
export { ForwardRef as ReactComponent };